'use strict';

var Params = function Params(adjustedChartHeight) {
  return function (containerWidth) {
    var padding = {
      top: 5,
      bottom: 5,
      left: 0,
      right: 0
    };
    var height = adjustedChartHeight - (padding.top + padding.bottom);
    var width = containerWidth - (padding.left + padding.right);
    return {
      width: width,
      forceHeight: true,
      height: height,
      containerWidth: containerWidth,
      containerHeight: height + padding.top + padding.bottom,
      padding: padding,
      xAxisShift: 0,
      direction: 'vertical',
      yAxisShift: 0,
      isDisplayIndicator: true
    };
  };
};
module.exports = Params;